<header class="dialog-header">
  <h2 id="received-invoice-dialog-title">
    {{(detail?.Invoice?.Type || data.type) === 'CommissionCashInvoice' ? 'Provisionsfaktura' : 'Självfaktura'}}
    {{detail?.Invoice?.InvoiceNumber || data.invoiceNumber}}
  </h2>
  <button mat-icon-button mat-dialog-close type="button" aria-label="Stäng dialogen" matTooltip="Stäng">
    <mat-icon>close</mat-icon>
  </button>
</header>

<mat-dialog-content class="dialog-content" [attr.aria-busy]="loading">
  <div *ngIf="loading" class="loading-state" role="status">
    <p>Hämtar fakturaunderlag…</p>
    <div *ngFor="let row of [1,2,3,4,5]" class="skeleton" aria-hidden="true"></div>
  </div>
  <div *ngIf="error" class="error-state">
    <p role="alert">{{error}}</p>
    <button mat-stroked-button type="button" (click)="load()">Försök igen</button>
  </div>

  <ng-container *ngIf="detail?.Invoice as invoice">
    <section aria-labelledby="received-invoice-info">
      <h3 id="received-invoice-info">Fakturauppgifter</h3>
      <dl class="info-grid">
        <div><dt>Avsändare</dt><dd>{{invoice.Sender || '–'}}</dd></div>
        <div><dt>Kund</dt><dd>{{invoice.Customer || '–'}}</dd></div>
        <div><dt>Fakturanummer</dt><dd>{{invoice.InvoiceNumber || '–'}}</dd></div>
        <div><dt>Status</dt><dd>{{invoice.Status || '–'}}</dd></div>
        <div><dt>Skapad</dt><dd>{{date(invoice.Created)}}</dd></div>
        <div><dt>Förfallodatum</dt><dd>{{date(invoice.PaymentDue)}}</dd></div>
        <div><dt>Inbetalningsdatum</dt><dd>{{date(invoice.PaymentDate)}}</dd></div>
        <div><dt>Typ</dt><dd>{{invoice.Type === 'CommissionCashInvoice' ? 'Provisionsfaktura' : 'Ersättning/delning'}}</dd></div>
      </dl>
      <p *ngIf="invoice.ReferenceText" class="reference"><strong>Referens:</strong> {{invoice.ReferenceText}}</p>
    </section>

    <section aria-labelledby="received-invoice-amounts">
      <h3 id="received-invoice-amounts">Belopp och avgifter</h3>
      <dl class="amounts">
        <div class="invoice-total"><dt>{{invoice.Type === 'CommissionCashInvoice' ? 'Provision' : 'Fakturabelopp'}}</dt><dd>{{invoice.TotalInvoiceAmount | number:'1.0-2'}} {{invoice.Currency}}</dd></div>
        <div><dt>Serviceavgift</dt><dd>{{invoice.ServiceFee | number:'1.0-2'}} SEK</dd></div>
        <div><dt>Moms på serviceavgift</dt><dd>{{invoice.ServiceFeeVat | number:'1.0-2'}} SEK</dd></div>
        <div><dt>Summa avgifter</dt><dd>{{invoice.FeesTotalAmount | number:'1.0-2'}} SEK</dd></div>
      </dl>
    </section>

    <section *ngIf="invoice.Groups?.length" aria-labelledby="received-invoice-rows">
      <h3 id="received-invoice-rows">Fakturarader</h3>
      <article *ngFor="let group of invoice.Groups" class="invoice-group">
        <div class="group-heading"><h4>{{group.Description || 'Fakturapost'}}</h4><p>{{group.Amount | number:'1.0-2'}} {{invoice.Currency}}</p></div>
        <div class="table-scroll" *ngIf="group.Rows?.length">
          <table>
            <thead><tr><th>Beskrivning</th><th>Från</th><th>Till</th><th>Tid</th></tr></thead>
            <tbody><tr *ngFor="let row of group.Rows">
              <td>{{row.Description || '–'}}</td><td>{{date(row.StartDate)}}</td><td>{{date(row.EndDate)}}</td>
              <td><ng-container *ngIf="row.HoursWorked != null || row.MinutesWorked != null; else noTime">{{row.HoursWorked || 0}} tim {{row.MinutesWorked || 0}} min</ng-container><ng-template #noTime>–</ng-template></td>
            </tr></tbody>
          </table>
        </div>
      </article>
    </section>

    <section *ngIf="invoice.Allowances?.length || invoice.Deductions?.length" aria-labelledby="received-invoice-expenses">
      <h3 id="received-invoice-expenses">Reseersättningar och utlägg</h3>
      <dl class="amounts">
        <div *ngFor="let allowance of invoice.Allowances"><dt>{{allowance.ReasonForTravel || 'Reseersättning'}}</dt><dd>{{allowance.Sum | number:'1.0-2'}}</dd></div>
        <div *ngFor="let deduction of invoice.Deductions"><dt>{{deduction.Description || 'Utlägg'}}</dt><dd>{{deduction.Amount | number:'1.0-2'}}</dd></div>
      </dl>
    </section>

    <section aria-labelledby="received-invoice-documents">
      <h3 id="received-invoice-documents">Dokument</h3>
      <div class="document-actions" *ngIf="detail.Documents?.length; else noDocuments">
        <button mat-stroked-button type="button" *ngFor="let file of detail.Documents" (click)="files.openFile(file)">
          <mat-icon aria-hidden="true">description</mat-icon>{{file.Name}}
        </button>
      </div>
      <ng-template #noDocuments><p>Inga dokument bifogade.</p></ng-template>
    </section>
  </ng-container>
</mat-dialog-content>
